import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useEffect, useState } from 'react';
import { store } from './store/store';
import Login3D from './components/Login3D';
import SplashScreen from './components/SplashScreen';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { startAutoUpdater, cleanOldCache } from './utils/autoUpdater';
import Dashboard from './components/Dashboard';
import Cotizaciones from './components/Cotizaciones';
import OrdenesVenta from './components/OrdenesVenta';
import OrdenesCompra from './components/OrdenesCompra';
import EnTransito from './components/EnTransito';
import ClientsPage from './pages/ClientsPage';
import SuppliersPage from './pages/SuppliersPage';
import Equipo from './components/Equipo';
import Urgencias from './components/Urgencias';
import Calendario from './components/Calendario';
import Finanzas from './components/Finanzas';
import Manual from './components/Manual';
import Perfil from './components/Perfil';
import MatrizExcelPaperBoatFinal from './components/MatrizExcelPaperBoatFinal';
import SuperAdminPanel from './components/SuperAdminPanel';
import ConfiguracionEmpresa from './components/ConfiguracionEmpresa';
import Historial from './components/Historial';
import DocumentosPage from './components/documents/DocumentosPage';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { EmpresaProvider } from './contexts/EmpresaContext';
import './styles/Login.css';

function App() {
  // Show splash screen only if user is not authenticated
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  const [showSplash, setShowSplash] = useState(!isAuthenticated);
  const [splashCompleted, setSplashCompleted] = useState(isAuthenticated);

  useEffect(() => {
    // Limpiar caché viejo al inicio
    cleanOldCache();

    // Iniciar sistema de auto-actualización
    startAutoUpdater();
  }, []);

  const handleSplashComplete = () => {
    setSplashCompleted(true);
    // Delay para permitir que la transición termine
    setTimeout(() => {
      setShowSplash(false);
    }, 1000);
  };

  // Solo mostrar el contenido cuando el splash esté completo o si ya está autenticado
  const showContent = !showSplash || isAuthenticated;

  return (
    <Provider store={store}>
      <EmpresaProvider>
        {showSplash && !isAuthenticated && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10000,
            opacity: splashCompleted ? 0 : 1,
            transition: 'opacity 1s ease-out',
            pointerEvents: 'none',
            backgroundColor: '#c4fffc'
          }}>
            <SplashScreen onComplete={handleSplashComplete} />
          </div>
        )}
        {showContent && (
        <Router>
        <ScrollToTop />
        <Routes>
        <Route path="/login" element={<Login3D />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cotizaciones"
          element={
            <ProtectedRoute>
              <Layout>
                <Cotizaciones />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ordenes-venta"
          element={
            <ProtectedRoute>
              <Layout>
                <OrdenesVenta />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ordenes-compra"
          element={
            <ProtectedRoute>
              <Layout>
                <OrdenesCompra />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/en-transito"
          element={
            <ProtectedRoute>
              <Layout>
                <EnTransito />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clientes"
          element={
            <ProtectedRoute>
              <Layout>
                <ClientsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/proveedores"
          element={
            <ProtectedRoute>
              <Layout>
                <SuppliersPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/equipo"
          element={
            <ProtectedRoute>
              <Layout>
                <Equipo />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/urgencias"
          element={
            <ProtectedRoute>
              <Layout>
                <Urgencias />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/calendario"
          element={
            <ProtectedRoute>
              <Layout>
                <Calendario />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/finanzas"
          element={
            <ProtectedRoute>
              <Layout>
                <Finanzas />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/matriz"
          element={
            <ProtectedRoute>
              <Layout>
                <MatrizExcelPaperBoatFinal />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/manual"
          element={
            <ProtectedRoute>
              <Layout>
                <Manual />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <Layout>
                <Perfil />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/super-admin"
          element={
            <ProtectedRoute>
              <Layout>
                <SuperAdminPanel />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/empresa"
          element={
            <ProtectedRoute>
              <Layout>
                <ConfiguracionEmpresa />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/documentos"
          element={
            <ProtectedRoute>
              <Layout>
                <DocumentosPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/historial"
          element={
            <ProtectedRoute>
              <Layout>
                <Historial />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </Router>
        )}
      </EmpresaProvider>
    </Provider>
  );
}

export default App
